import { Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { DashLayout } from "@/components/DashLayout";
import { QrCard } from "@/components/QrCard";
import { useAuth } from "@/context/AuthContext";
import { USER_NAV } from "@/pages/navs";

export default function StaticQR() {
  const { user } = useAuth();
  const link = `${window.location.origin}/pay/${user?.username}`;
  const copy = () => { navigator.clipboard.writeText(link); toast.success("Pay link copied"); };

  return (
    <DashLayout nav={USER_NAV} title="Static QR" subtitle="Share your QR or pay link with customers">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.2fr]">
        <div className="min-w-0"><QrCard name={user?.business_name || user?.name} upi={user?.upi_id} qr={user?.qr_url} /></div>
        <div className="min-w-0 space-y-4">
          <div className="rounded-xl border border-slate-200 bg-white p-5 sm:p-6">
            <h3 className="font-display text-lg font-semibold text-[#0A1F44]">Public pay link</h3>
            <p className="mt-1 text-sm text-slate-500">Customers can open this link to see your QR and UPI ID.</p>
            <div className="mt-4 flex flex-col gap-2 sm:flex-row">
              <div className="min-w-0 flex-1 break-all rounded-lg bg-slate-50 px-4 py-3 font-mono text-xs text-slate-700 sm:text-sm" data-testid="pay-link-text">{link}</div>
              <button onClick={copy} data-testid="copy-pay-link-btn" className="flex items-center justify-center gap-2 rounded-lg bg-[#2563EB] px-4 py-3 text-sm font-semibold text-white hover:bg-[#1D4ED8]"><Copy className="h-4 w-4" /> Copy</button>
              <a href={link} target="_blank" rel="noreferrer" data-testid="open-pay-link-btn" className="flex items-center justify-center gap-2 rounded-lg border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"><ExternalLink className="h-4 w-4" /> Open</a>
            </div>
          </div>
          <div className="rounded-xl border border-slate-200 bg-white p-5 sm:p-6">
            <h3 className="font-display text-lg font-semibold text-[#0A1F44]">How settlement works</h3>
            <ol className="mt-3 space-y-2 text-sm text-slate-600">
              <li>1. Customer scans your static QR and pays via UPI.</li>
              <li>2. YesPayBizz verifies the payment using the 12-digit UTR.</li>
              <li>3. Amount is credited to your Collection wallet.</li>
              <li>4. Funds moved to Payout wallet can be withdrawn to your bank.</li>
            </ol>
          </div>
        </div>
      </div>
    </DashLayout>
  );
}
